import {
  ChatQuestionRenderProps,
  CircleOrCrossOutStatements,
  ContentIsScamOrNot,
  CorrectlyOrderRenderProps,
  FakeWebsiteRenderProps,
  ImageIsScamOrNotProps,
  MatchStatementsQuestion,
  PasswordInputRenderProps,
  SearchResultRenderProps,
  SeveralOptionRenderProps,
  WhoIsRightRenderProps,
  YesNoRenderProps,
} from "./config/renderProps";
import {
  profiles,
  ages,
  languages,
  badgeIds,
  renderTemplates,
  // questions
} from "./config";
import { QuizModuleId } from "./config/quizModules";

export type RenderProp =
  | YesNoRenderProps
  | ChatQuestionRenderProps
  | WhoIsRightRenderProps
  | SearchResultRenderProps
  | PasswordInputRenderProps
  | SeveralOptionRenderProps
  | FakeWebsiteRenderProps
  | CorrectlyOrderRenderProps
  | MatchStatementsQuestion
  | CircleOrCrossOutStatements
  | ImageIsScamOrNotProps
  | ContentIsScamOrNot;
export type Profile = (typeof profiles)[number];
export type Age = (typeof ages)[number];
export type BadgeId = (typeof badgeIds)[number];
export type QuestionId = string;
export type QuestionVariant = string;
export type RenderTemplate = (typeof renderTemplates)[number];

export type Language = (typeof languages)[number];
export type TranslationData = Record<Language, string>;
export type CorrectOrIncorrect = "correct" | "incorrect";

export interface SocialShare {
  textToShare: TranslationData;
  imageToShare: string;
}

export interface Question {
  // relatedQuizModules: Array<QuizModuleId>;
  id: TranslationData;
  variant: TranslationData;
  fitsAges: Array<Age>;
  fitsProfiles: Array<Profile>;
  badge: BadgeId;
  renderTemplate: RenderTemplate;
  renderProps?: RenderProp;
  title: TranslationData;
  desc: TranslationData;
  correctResultTitle: TranslationData;
  correctResultDescInnerHTML: TranslationData;
  incorrectResultTitle: TranslationData;
  incorrectResultDescInnerHTML: TranslationData;
  readMoreInnerHTML?: TranslationData;
  youtubeVideoID?: string;
  socialShareOverride?: SocialShare;
}

export type QuestionKey = keyof Question;
export type Questions = Array<Question>;

export const isTranslationData = (a: any): a is TranslationData => {
  if (typeof a !== "object" || !a) return false;
  return "sv" in a;
};

export const isAge = (a: any): a is Age => {
  if (typeof a !== "string") return false;
  return ages.some((age) => a === age);
};

export const isAges = (a: any): a is Array<Age> => {
  if (!Array.isArray(a)) return false;
  return a.every((elem: string) => isAge(elem));
};

export const isProfile = (a: any): a is Profile => {
  if (typeof a !== "string") return false;
  return profiles.some((profile) => a === profile);
};

export const isProfiles = (a: any): a is Array<Profile> => {
  if (!Array.isArray(a)) return false;
  return a.every((elem: string) => isProfile(elem));
};

export const isBadgeId = (a: any): a is BadgeId => {
  if (typeof a !== "string") return false;
  return badgeIds.some((id) => id === a);
};

export const isBadgeIds = (a: any): a is Array<BadgeId> => {
  if (!Array.isArray(a)) return false;
  return a.every((elem: string) => isBadgeId(elem));
};

// export const isQuestionId = (a: any): a is QuestionId => {
//   if (typeof a !== "string") return false;
//   return questions.some((question) => Object.values(question.id).includes(a));
// };

// export const isQuestionIds = (a: any): a is Array<QuestionId> => {
//   if (!Array.isArray(a)) return false;
//   return a.every((elem: string) => isQuestionId(elem));
// };
